import ExtensionCapability from '../../capability';
import { Specs, attachHandler } from '@doxyme/extensions-common';

type Constraints = Specs.PhotoCapture.Constraints;

const { PhotoCapture } = Specs;

type StartHandler = () => void;

/**
 * Photo Capture allows extensions to use the photo capture service within the host application.
 */
export default class PhotoCaptureCapability extends ExtensionCapability<Constraints> {
  static readonly id = PhotoCapture.id;

  protected readonly startHandlers: StartHandler[] = [];

  constructor() {
    super(PhotoCapture);

    this.handlers.push([PhotoCapture.Actions.Start, this.start.bind(this)]);
  }

  private start(): void {
    for (const handler of this.startHandlers) {
      handler();
    }
  }

  onStart(handler: StartHandler): () => void {
    return attachHandler<StartHandler>(this.startHandlers, handler);
  }
}
